import { dayjsNow } from '@/Infrastructure/Utilities/dayjs.type';
import { ExtendedTractor } from '@hooks/useDriverTractors.types';

interface TractorSelectionStatus {
  /** Flag indicating that the Driver is in adequate status to be selected */
  isSelectable: boolean;
  /** If the Driver is unable to be selected, this contains each reason why */
  disabledReason: string[];
}

export function isTractorSelectable(row: ExtendedTractor, requiresHazmatCert?: boolean): TractorSelectionStatus {
  let isValidForSelection = true;
  const disabledReasons: string[] = [];

  const today = dayjsNow().valueOf();

  const isHazmatDriverAvailable =
    row.drivers?.length === 1
      ? !!row.drivers[0].hazmatExpirationDate && !(row.drivers[0].hazmatExpirationDate.unix < today)
      : row.drivers?.some((driver) => !!driver.hazmatExpirationDate && !(driver.hazmatExpirationDate.unix < today));

  if (requiresHazmatCert && !isHazmatDriverAvailable) {
    isValidForSelection = false;
    disabledReasons.push('Hazmat Certified Driver is required.');
  }

  return {
    isSelectable: isValidForSelection,
    disabledReason: disabledReasons
  };
}
